import * as React from 'react';
import { LocalizePropType } from 'getaway-data-layer';
import './BubMigrationView.less';
import SlideItem from '../SlideItem/SlideItem';
import BrandButton from '../BrandButton/BrandButton';
import BrandIcon from '../BrandIcon/BrandIcon';

type Props = {
  localize: LocalizePropType;
  onCTA?: () => void;
  onSecondaryCTA?: () => void;
  showSecondaryCTA: boolean;
  title: string;
  description: string;
  ctaText: string;
  secondaryCTAText: string;
  showClose?: boolean;
  onClose?: () => void;
};

const BubMigrationView: React.FC<Props> = ({
  localize,
  title,
  description,
  ctaText,
  secondaryCTAText,
  onCTA,
  onSecondaryCTA,
  showSecondaryCTA = false,
  showClose = false,
  onClose,
}) => {
  return (
    <div className="screen-container" style={{ zIndex: 2001 }}>
      <div className="screen-body" style={{ padding: 0 }}>
        {showClose && (
          <div className="close" onClick={onClose}>
            <img
              src="/images/closeIconBlack.png"
              alt="close"
              style={{ width: 28, height: 28 }}
            />
          </div>
        )}
        <div className="bottomContainer">
          <BrandButton
            id="bub-cta"
            title={localize(ctaText)}
            onClick={onCTA}
            containerStyles={{ position: 'unset', width: '100%' }}
          />
          {showSecondaryCTA && (
            <div className="link" onClick={onSecondaryCTA}>
              <div className="linkText">{localize(secondaryCTAText)}</div>
            </div>
          )}
        </div>

        <SlideItem
          title={localize(title)}
          description={localize(description)}
          imageSrc={'/images/bubMigration.png'}
          imageStyles={{ height: 'calc(100vh - 72%)' }}
          titleStyles={{ padding: '15px 24px' }}
          descriptionStyles={{ padding: '0 24px' }}
        />
      </div>
    </div>
  );
};

export default BubMigrationView;
